import config from 'constants/config'
import GeoContext from 'contexts/geoContext'
import useNavigateTo from 'hooks/useNavigateTo'
import useWhiteLabelAppConfig from 'hooks/useWhiteLabelAppConfig'
import { addRegionToPath } from 'lib/url/searchUrlUtils'
import { postMessageToWhiteLabelApp } from 'lib/whitelabels/whitelabels'
import { useCallback, useContext } from 'react'

/**
 * Click handler for an internal route that should leave the white label app: inside the iOS
 * app it hands the route over so the app opens it in the device's default browser, everywhere
 * else (Android app and web) it navigates in place as usual.
 *
 * The app's `openInBrowser` handler only accepts absolute http(s) URLs, so the route is
 * resolved against the business portal base url with the current region.
 */
function useWhiteLabelAppExternalLink(path: string): () => void {
  const { isApp, isIOS } = useWhiteLabelAppConfig()
  const { currentRegionCode } = useContext(GeoContext)
  const navigateTo = useNavigateTo()

  return useCallback(() => {
    if (isApp && isIOS) {
      postMessageToWhiteLabelApp({
        openInBrowser: { url: `${config.businessTraveller.businessPortalHref}${addRegionToPath(path, currentRegionCode)}` },
      })
      return
    }

    navigateTo(path)
  }, [currentRegionCode, isApp, isIOS, navigateTo, path])
}

export default useWhiteLabelAppExternalLink
